import { useCallback, useEffect, useRef, useState } from 'react';

const clearSearchFilter = (prev) =>
  prev.search ? { ...prev, search: '' } : prev;

export const useVesselSalesSearch = ({ fetchVoyagesPage, setFilters }) => {
  const [quickFilterValues, setQuickFilterValues] = useState([]);
  const [searchRaw, setSearchRaw] = useState('');
  const searchInputRef = useRef(null);
  const debounceRef = useRef(null);

  const clearSearch = useCallback(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (searchInputRef.current) searchInputRef.current.value = '';
    setSearchRaw('');
    setQuickFilterValues([]);
    setFilters(clearSearchFilter);
    fetchVoyagesPage(1, '');
  }, [fetchVoyagesPage, setFilters]);

  const handleSearchChange = useCallback(() => {
    const value = searchInputRef.current?.value ?? '';
    setSearchRaw(value);
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      const trimmed = value.trim();
      const words = trimmed ? trimmed.split(/\s+/) : [];
      setQuickFilterValues(words);
      setFilters((prev) => ({ ...prev, search: trimmed }));
      fetchVoyagesPage(1, trimmed);
    }, 1000);
  }, [fetchVoyagesPage, setFilters]);

  const resetSearchForTab = useCallback(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (searchInputRef.current) searchInputRef.current.value = '';
    setSearchRaw('');
    setQuickFilterValues([]);
    setFilters(clearSearchFilter);
  }, [setFilters]);

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, []);

  return {
    quickFilterValues,
    searchRaw,
    searchInputRef,
    clearSearch,
    handleSearchChange,
    resetSearchForTab,
  };
};
